import {
  NonSerializedInventoryTransfer,
  NonSerializedInventoryTransferItem,
  TransferData,
} from 'src/app/proto/generated/inv_non_serialized_inventory_message_pb';

export class NonSerializedInventoryTransferDataModel {
  location: string;
  quantity: number;

  static MapperProto(source: NonSerializedInventoryTransferDataModel): TransferData {
    const destination = new TransferData();
    if (!source) {
      return destination;
    }

    destination.setLocationName(source.location || '');
    destination.setQuantity(source.quantity ?? 0);
    return destination;
  }
}

export class NonSerializedInventoryTransferItemModel {
  nonSerializedInventoryName: string;
  transfers: NonSerializedInventoryTransferDataModel[] = [];

  static MapperProto(
    source: NonSerializedInventoryTransferItemModel
  ): NonSerializedInventoryTransferItem {
    const destination = new NonSerializedInventoryTransferItem();
    if (!source) {
      return destination;
    }

    destination.setNonSerializedInventoryName(
      source.nonSerializedInventoryName || ''
    );
    destination.setTransfersList(
      (source.transfers || []).map((transfer) =>
        NonSerializedInventoryTransferDataModel.MapperProto(transfer)
      )
    );

    return destination;
  }
}

export class NonSerializedInventoryTransferModel {
  sourceLocationName: string;
  nonSerializedInventories: NonSerializedInventoryTransferItemModel[] = [];

  static MapperProto(
    source: NonSerializedInventoryTransferModel
  ): NonSerializedInventoryTransfer {
    const destination = new NonSerializedInventoryTransfer();
    if (!source) {
      return destination;
    }

    destination.setSourceLocationName(source.sourceLocationName || '');
    destination.setNonSerializedInventoriesList(
      (source.nonSerializedInventories || []).map((inventory) =>
        NonSerializedInventoryTransferItemModel.MapperProto(inventory)
      )
    );

    return destination;
  }
}
